import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function BudgetlineFormReducer(state = initialState.budgetlineForm, action: any) {
  switch (action.type) {
    case types.SAVE_BUDGETLINEFORM_SUCCESS:
      return action.budgetlineForm;
    default:
      return state;
  }
}
